// Per the SSE spec, multi-line content is sent as multiple `data:` fields per
// event and must be rejoined with `\n` on the client. The previous implementation
// dropped these because it treated each `data:` line as its own chunk, so any
// `\n` in the payload was lost.
export function parseSseEvents(buffer: string): { events: string[]; remainder: string } {
  const parts = buffer.split('\n\n');
  const remainder = parts.pop() ?? '';
  const events: string[] = [];
  for (const part of parts) {
    const dataLines: string[] = [];
    for (const line of part.split('\n')) {
      if (line.startsWith('data: ')) dataLines.push(line.slice(6));
    }
    if (dataLines.length > 0) events.push(dataLines.join('\n'));
  }
  return { events, remainder };
}
